const toRad = (d) => (d * Math.PI) / 180;
const km = (a, b) => {
  const h = Math.sin(toRad(b[0] - a[0]) / 2) ** 2 + Math.cos(toRad(a[0])) * Math.cos(toRad(b[0])) * Math.sin(toRad(b[1] - a[1]) / 2) ** 2;
  return 12742 * Math.asin(Math.sqrt(h));
};
const pt = (o) => [o.customer.lat, o.customer.lng];
const place = (o) => (o.customer.lat != null ? pt(o).join(",") : o.customer.address);

export const MAX_STOPS = 10;

export function orderStops(store, orders) {
  const pool = orders.filter((o) => o.customer.lat != null);
  const rest = orders.filter((o) => o.customer.lat == null);
  if (!store) return [...pool, ...rest];
  const out = [];
  let cur = store;
  while (pool.length) {
    pool.sort((a, b) => km(cur, pt(a)) - km(cur, pt(b)));
    const next = pool.shift();
    out.push(next);
    cur = pt(next);
  }
  return [...out, ...rest];
}

export function routeUrl(store, stops) {
  const p = new URLSearchParams({ api: "1", travelmode: "driving", destination: place(stops[stops.length - 1]) });
  if (store) p.set("origin", store.join(","));
  if (stops.length > 1) p.set("waypoints", stops.slice(0, -1).map(place).join("|"));
  return `https://www.google.com/maps/dir/?${p}`;
}

export function courierText(storeName, stops, url, labels) {
  const lines = stops.map((o, i) => [
    `${i + 1}) #${o.number} · ${o.customer.name}${o.customer.phone ? ` · ${o.customer.phone}` : ""}`,
    `   ${o.customer.address}`,
    `   R$ ${o.total.toFixed(2).replace(".", ",")} · ${labels[o.payment_method] || o.payment_method}${o.online?.status === "approved" ? " (pago online)" : ""}${o.change_for > 0 ? ` · troco p/ R$ ${o.change_for.toFixed(2).replace(".", ",")}` : ""}`,
  ].join("\n"));
  return `Rota de entrega · ${storeName}\n\n${lines.join("\n\n")}\n\nAbrir rota: ${url}`;
}

export const trackUrl = (slug, o) => `${window.location.origin}/cardapio/${slug}?pedido=${o.id}`;

export function departureText(o, storeName, url) {
  const left = Math.round((new Date(o.created_at).getTime() + (o.eta_minutes || 0) * 60000 - Date.now()) / 60000);
  const when = left > 2 ? `deve chegar em cerca de ${left} min` : "deve chegar em instantes";
  return `Olá, ${o.customer.name.split(" ")[0]}! Seu pedido #${o.number} da ${storeName} saiu para entrega e ${when}. Acompanhe: ${url}`;
}

export const ratingText = (o, storeName, url) =>
  `Olá, ${o.customer.name.split(" ")[0]}! Obrigado por pedir na ${storeName}. Como foi o seu pedido #${o.number}? Deixe sua nota em 1 toque: ${url}`;
